import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider, useTheme, DARK, LIGHT } from './context/ThemeContext';
import { About } from './components/Aboutme';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Footer } from './components/Footer';
import Skills from './components/Skills';
import Experience from './components/Experience';

import Education from './components/Education';
import { Contact } from './components/Contact';
import { Blog } from './components/Blog';
import Projects from './components/Project';


function AppContent() {

  const { isDark } = useTheme();
  const t = isDark ? DARK : LIGHT;

  return (

    <div style={{
      background: t.bg,
      color: t.text,
      minHeight: "100vh",
      transition: "background 0.3s, color 0.3s",
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
    }}>
      <NavBar />
      <Banner />
      <About />
      <Skills />
      <Experience />
      <Education />
      <Projects/>
      <Blog />
      <Contact />
      <Footer />
      
    </div>



    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
